// extracted by mini-css-extract-plugin
export default {"LeadsHealthMeterBox":"lyvluY3vuCalGZh0znJ_","LeadsHealthMeter__imagebox":"amGVbphttdwq53WO8eCa","LeadsHealthMeter__image":"yFsVsp9SXMnAbj4Ll04y","LeadsHealthMeter__reload":"nMsxjbp3IPElWLxivITq","LeadsHealthMeter__pannel":"pFRudO5sAiKT9UI1bVMT","LeadsHealthMeter__rotate":"oJ0KRaVLSrOsYGpfH_zw","LeadsHealthMeter__rotatedot":"R0dLLkaWqcdY7OmeNQMv","LeadsHealthMeter__rotatearrow":"iba8PlKQAaQ5vudbCQcX","LeadsHealthMeter__textbox":"pVAg1aS8EfEiKK815bUh"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"LeadsHealthMeterBox\":\"lyvluY3vuCalGZh0znJ_\",\"LeadsHealthMeter__imagebox\":\"amGVbphttdwq53WO8eCa\",\"LeadsHealthMeter__image\":\"yFsVsp9SXMnAbj4Ll04y\",\"LeadsHealthMeter__reload\":\"nMsxjbp3IPElWLxivITq\",\"LeadsHealthMeter__pannel\":\"pFRudO5sAiKT9UI1bVMT\",\"LeadsHealthMeter__rotate\":\"oJ0KRaVLSrOsYGpfH_zw\",\"LeadsHealthMeter__rotatedot\":\"R0dLLkaWqcdY7OmeNQMv\",\"LeadsHealthMeter__rotatearrow\":\"iba8PlKQAaQ5vudbCQcX\",\"LeadsHealthMeter__textbox\":\"pVAg1aS8EfEiKK815bUh\"}";
        // 1779800065508
        var cssReload = require("../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  